import * as Sentry from '@sentry/browser'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

const isPasswordSetRoute = (route: RouteLocationNormalizedGeneric) => {
  return route.hash.startsWith('#/password-set')
}
const isPrivateRoute = (route: RouteLocationNormalizedGeneric) => {
  const { isPublicRoute } = usePublicRoutes()
  if (typeof route.name !== 'string') {
    return true
  }
  return !isPublicRoute(route.name)
}

export default defineNuxtRouteMiddleware(async (to) => {
  try {
    const { getEffectiveAuthToken } = useEffectiveAuthToken()
    if (isPasswordSetRoute(to)) {
      return navigateTo(to.hash.replace('#', ''))
    }
    const authToken = await getEffectiveAuthToken()
    if (!authToken && isPrivateRoute(to)) {
      return navigateTo({ path: '/login', query: to.query })
    }
  } catch (error) {
    Sentry.captureException(error)
    const snackbar = useSnackbar()
    snackbar.error('An error occurred during route authentication. Please try again.')
  }
})
